<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">İlaç Deposu Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Depo kartlarını
                                        buradan ekleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Depo Adı: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="warehouseName"
                                            placeholder="Depo Adı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Depo Konumu: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="warehouseLocation"
                                            placeholder="Depo Konumu">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Açıklama: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="warehouseDescription"
                                            placeholder="Açıklama">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Varsayılan Depo: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="form-check form-switch form-switch-lg">
                                        <input class="form-check-input c-pointer" type="checkbox" checked="true"
                                            v-model="warehouseDefault">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Aktif Depo: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="form-check form-switch form-switch-lg">
                                        <input class="form-check-input c-pointer" type="checkbox" checked="true"
                                            v-model="warehouseActive">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default {
    name: 'CreateWarehouse',
    data() {
        return {
            warehouseName: "",
            warehouseLocation: "",
            warehouseDescription: "",
            warehouseDefault: "",
            warehouseActive: ""
        }
    },
    async mounted() {

    },
    methods: {
        async submitForm() {
            const formData = new FormData();
            formData.append('name', this.warehouseName);
            formData.append('location', this.warehouseLocation);
            formData.append('description', this.warehouseDescription);
            formData.append('default', this.warehouseDefault);
            formData.append('active', this.warehouseActive);
            console.log(formData);

            try {
                const response = await this.$axios.post('warehouse/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
                this.$router.push({ name: 'Warehousess', params: { page: 1 } });
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>